var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHalfEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 34,
    viewBox: "0 0 59 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7694 34C58.0406 32.4041 58.1818 30.764 58.1818 29.0909C58.1818 13.0244 45.1574 0 29.0909 0C13.0244 0 0 13.0244 0 29.0909C0 30.764 0.141243 32.4041 0.412456 34H4.26034C3.94815 32.4119 3.78452 30.7705 3.78452 29.0909C3.78452 15.1146 15.1146 3.78452 29.0909 3.78452C43.0672 3.78452 54.3973 15.1146 54.3973 29.0909C54.3973 30.7705 54.2337 32.4119 53.9215 34H57.7694Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfEllipse);
export default __webpack_public_path__ + "static/media/halfEllipse.8b038ce257e7d2c018a21fac8035874f.svg";
export { ForwardRef as ReactComponent };